import React from 'react';
import { Card, CardContent, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import PFinRow from '../PFinRow/PFinRow';
import _ from 'lodash';

const yearHeaderStyle = { color: 'grey', borderBottom: 'solid 3px grey', minWidth: '50px' };
const principalHeaderStyle = { color: 'grey', borderBottom: 'solid 3px #3966f8' };
const cashValueHeaderStyle = { color: 'grey', borderBottom: 'solid 3px #665EFF' };
const expenseHeaderStyle = { color: 'grey', borderBottom: 'solid 3px #FFC000' };
const returnHeaderStyle = { color: 'grey', borderBottom: 'solid 3px #0FAF3F' };
const cashBackHeaderStyle = { color: 'grey', borderBottom: 'solid 3px #3EC7F8' };
const irrHeaderStyle = { color: 'grey', borderBottom: 'solid 3px #665EFF' };

const PFinTable = ({
  intl,
  years,
  principal,
  base,
  bankLoanInterest,
  firstYearBonus,
  yearlyData,
  overrideLoanInterest,
  rowOpen,
  onToggleOpen,
  showIRR,
  onSelectRow
}) => (
  <Card className="pfa-item-details-card pfa-card orange">
    <CardContent style={{ paddingTop: 4 }}>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell align="center" style={yearHeaderStyle}>
                {intl.formatMessage({ id: 'Year' })}
              </TableCell>
              <TableCell align="center" style={principalHeaderStyle}>
                {intl.formatMessage({ id: 'pfa-base' })}
              </TableCell>
              <TableCell align="center" style={expenseHeaderStyle}>
                {intl.formatMessage({ id: 'pfa-total-expense' })}
              </TableCell>
              <TableCell align="center" style={cashValueHeaderStyle}>
                {intl.formatMessage({ id: 'pfa-cash-value' })}
              </TableCell>
              <TableCell align="center" style={cashBackHeaderStyle}>
                {intl.formatMessage({ id: 'pfa-net-cash' })}
              </TableCell>
              <TableCell align="center" style={showIRR ? irrHeaderStyle : returnHeaderStyle}>
                {intl.formatMessage({ id: showIRR ? 'pfa-irr-col' : 'pfa-return' })}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {years.map((e, i) =>
              i !== 0 ? (
                <PFinRow
                  onSelectRow={() => onSelectRow(i)}
                  key={i}
                  principal={principal}
                  base={base}
                  bankLoanInterest={bankLoanInterest}
                  term={e}
                  firstYearBonus={firstYearBonus}
                  overrideLoanInterest={overrideLoanInterest}
                  {...yearlyData}
                  i={i}
                  intl={intl}
                  open={_.get(rowOpen, `[${i}]`, false)}
                  onToggleOpen={onToggleOpen}
                  showIRR={showIRR}
                />
              ) : null
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </CardContent>
  </Card>
);

export default PFinTable;
